import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DialogService } from '../../../../services/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { DatePipe } from '@angular/common'

@Component({
    selector: 'autoremoteresetcommand-add-dialog',
    templateUrl: './autoremoteresetcommand-add-dialog.component.html',
    styleUrls: ['../../../../style/custom-mat-dialog.component.less'],
    standalone: false
})


export class AutoRemoteResetCommandAddDialogComponent implements OnInit {

    submitted = false;
    form: FormGroup;
    commandKeys: any[] = [];

    constructor(
        private http: HttpClient,
        private confimDialog: DialogService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject('BASE_URL') private baseUrl: string,
        public dialogRef: MatDialogRef<AutoRemoteResetCommandAddDialogComponent>,
        private fb: FormBuilder,
        public defaults: DefaultValuesService,
        private formBuilder: FormBuilder,
        private datepipe: DatePipe
    ) {
        this.confimDialog.tthis = this;
        this.form = this.formBuilder.group({
            commandKey: ['', [Validators.required]],
        });
    }

    ngOnInit(): void {
        // Expect commandKeys to be passed in data from the list component
        if (this.data && this.data.commandKeys) {
            this.commandKeys = this.data.commandKeys;
        } else {
            console.log('No command keys available for this Controller and Tenant');
        }
    }

    get f() { return this.form.controls; }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }
        // Find the selected command object
        const selectedCommand = this.commandKeys.find(cmd => cmd.Key === this.form.value.commandKey);
        this.dialogRef.close(selectedCommand);
    }
}


